import PropTypes from 'prop-types'
import './article.css'

const Article = (props) => {
  return (
    <div className={`article-container1 ${props.rootClassName} `}>
      <div className="article-container2">
        <div className="article-heading">
          <div className="article-date-and-issue">
            <span id={props.postNumberId} className="article-post-number">
              {props.category}
            </span>
          </div>
          <h1 id="Article_Heading" className="article-article-heading">
            {props.title}
          </h1>
          <span id="Heading_Tagline" className="article-heading-tagline">
            {props.excerpt}
          </span>
          {props.description && (
            <span className="article-article-tags">
              {props.description}
            </span>
          )}
        </div>

        {props.imageUrl && (
          <div className="article-main-image">
            <img
              alt={props.imageAlt || 'Article image'}
              src={props.imageUrl}
              className="article-image1"
            />
            {props.imageCaption && (
              <span className="article-image-caption1">
                {props.imageCaption}
              </span>
            )}
          </div>
        )}

        <div className="article-introduction">
          {props.content}
        </div>

        {props.publishDate && (
          <span className="article-hashtags">
            Published: {props.publishDate}
          </span>
        )}
      </div>
    </div>
  )
}

Article.defaultProps = {
  postNumberId: 'article_post_number',
  rootClassName: '',
  imageAlt: 'Article image',
}

Article.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.string,
  excerpt: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  imageCaption: PropTypes.string,
  content: PropTypes.node.isRequired,
  publishDate: PropTypes.string,
  postNumberId: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Article
